import { Keybinding } from "./lib/keybindings"
import { Rect } from "./lib/viewport"
import { useGetViewport, useShortcut } from "./Editor"

/** The viewport's default keys; a builder merges them into its own keybindings. */
export const VIEWPORT_KEYBINDINGS: Record<string, Keybinding> = {
  ZOOM_IN: { key: "mod+equal, mod+=", description: "Zoom in", group: "Zoom" },
  ZOOM_OUT: { key: "mod+minus, mod+-", description: "Zoom out", group: "Zoom" },
  ZOOM_RESET: { key: "mod+digit0, shift+digit0", description: "Zoom to 100%", group: "Zoom" },
  ZOOM_TO_FIT: { key: "shift+digit1", description: "Zoom to fit", group: "Zoom" },
  ZOOM_TO_SELECTION: { key: "shift+digit2", description: "Zoom to selection", group: "Zoom" },
}

type Props = {
  /** The selection's bounds in content units, or null when nothing is selected. */
  getSelectionBounds?: () => Rect | null
}

/** Listens to the viewport's keys (VIEWPORT_KEYBINDINGS). */
const ViewportShortcuts = ({ getSelectionBounds }: Props) => {
  const getViewport = useGetViewport()

  useShortcut("ZOOM_IN", () => getViewport().zoomIn())
  useShortcut("ZOOM_OUT", () => getViewport().zoomOut())
  useShortcut("ZOOM_RESET", () => getViewport().resetZoom())
  useShortcut("ZOOM_TO_FIT", () => getViewport().zoomToFit())
  useShortcut("ZOOM_TO_SELECTION", () => {
    const bounds = getSelectionBounds?.()
    if (!bounds) return false
    getViewport().zoomToFit(bounds)

    return true
  })

  return null
}

export default ViewportShortcuts
